import { createContract } from './createContract'
import { createCustomer } from './createCustomer'
import { upsertProspect } from './upsertProspect'

export default {
  createContract,
  createCustomer,
  upsertProspect
}
